import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { BillingPanelShell } from '@/features/billing/components/BillingPanel/Layouts'
import { PATH_BILLING } from '@/routes/consts'
import { BillingInformation, General, InvoicesRoot, PaymentMethods, Subscriptions } from '../panel'

export const PanelRoot = () => {
  return (
    <Routes>
      <Route element={<BillingPanelShell />}>
        <Route index element={<General />} />
        <Route path={PATH_BILLING.SUBSCRIPTIONS} element={<Subscriptions />} />
        <Route path={PATH_BILLING.BILLING_INFORMATION} element={<BillingInformation />} />
        <Route path={PATH_BILLING.PAYMENT_METHODS} element={<PaymentMethods />} />
        <Route path={`${PATH_BILLING.INVOICES}/*`} element={<InvoicesRoot />} />
      </Route>

      <Route path={'*'} element={<Navigate to={'/'} replace={true} />} />
    </Routes>
  )
}
